// extracted by mini-css-extract-plugin
export var dividerLine = "_a4-3";
export var itemImage = "_a4-9";
export var lightDivider = "_a4-4";
export var modalContent = "_a4-5";
export var modalContentCompact = "_a4-6";
export var productCard = "_a4-a";
export var productImage = "_a4-b";
export var productImageCompact = "_a4-7";
export var productImagePlaceholder = "_a4-c";
export var productImagePlaceholderCompact = "_a4-8";
export var progressBarBackground = "_a4-1";
export var progressBarContainer = "_a4-0";
export var progressBarFill = "_a4-2";